import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function UCCSCEPMonitoring() {
  return (
    <div className="art-page">
      <SEO
        title="Independent Verification and Results Monitoring — Uganda Clean Cooking Supply Chain Expansion Project (UCCSCEP)"
        description="CIRCODU served as the field monitoring arm of the Independent Verification Agency (IVA) for the Uganda Clean Cooking Supply Chain Expansion Project (UCCSCEP), providing rigorous third-party monitoring and evaluation services."
        keywords="Uganda Clean Cooking Supply Chain Expansion Project, Independent Verification Agency, monitoring and evaluation, cookstove program, World Bank, ESMAP, clean cooking, Distribution Challenge Fund, stove adoption, fuel savings, household surveys, Kitchen Performance Tests, program accountability, CIRCODU, Uganda cookstove program monitoring, Independent Verification Agency Uganda, cookstove program evaluation Uganda, World Bank cookstove program Uganda, ESMAP cookstove program Uganda"
        url="/Independent-Verification-and-Results-Monitoring-Uganda-Clean-Cooking-Supply-Chain-Expansion-Project-UCCSCEP"
        datePublished="2020-12-12"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Independent Verification — Uganda Clean Cooking Supply Chain
              Expansion Project
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 12, 2020
            </div>
            <h1 className="art-title">
              Independent Verification and Results Monitoring — Uganda Clean
              Cooking Supply Chain Expansion Project (UCCSCEP)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                From 2016 to 2020, CIRCODU served as the field monitoring arm of
                the <strong>Independent Verification Agency (IVA)</strong> for
                the{" "}
                <strong>
                  Uganda Clean Cooking Supply Chain Expansion Project (UCCSCEP)
                </strong>{" "}
                — a World Bank and ESMAP-funded initiative that disbursed{" "}
                <strong>USD 2.2 million</strong> in competitive grants to
                manufacturer-distributor consortia to scale commercial
                distribution of improved cookstoves across Uganda. CIRCODU
                worked in association with <strong>KPMG</strong>, which led the
                overall IVA function. Together, they provided the credible,
                independent evidence base that underpinned the project's
                performance-based grant disbursement structure.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <ol>
                <li>
                  <strong>Laboratory:</strong> Water Boiling Tests on all eight
                  approved stove models, verifying performance standards before
                  and during distribution.
                </li>
                <li>
                  <strong>Field:</strong> Visits to more than{" "}
                  <strong>800 households</strong> across Uganda's project
                  districts, conducting KPTs and user surveys assessing
                  adoption, usage continuity, and economic and health outcomes.
                  Households were selected from distributor sales databases,
                  with a minimum of 24 users per consortium per round.
                </li>
                <li>
                  <strong>Factory/Warehouse:</strong> Spot-check audits on
                  production, sales, and marketing activities of each
                  participating consortium, verifying that reported sales
                  figures were supported by actual inventory and production
                  records.
                </li>
              </ol>
              <h2 className="art-subheading">Outcomes</h2>
              <p>
                By the project's close in 2020, <strong>72,535 stoves</strong>{" "}
                had been sold through the programme. Average monthly household
                fuel consumption among buyers fell by <strong>36%</strong>, with
                equivalent cost savings and emissions reductions. Women in
                project households reported{" "}
                <strong>30 to 90 minutes of freed time each day</strong>{" "}
                previously spent on fuel collection. The project was rated{" "}
                <strong>Satisfactory</strong> by the World Bank, with M&amp;E
                quality rated <strong>Substantial</strong> — outcomes to which
                CIRCODU's rigorous independent verification made a direct
                contribution.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's independent verification
                services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
